import posthog from "posthog-js";
import { useEffect, useRef } from "react";

import { AnalyticsQueryProvider } from "@/components/RequestsAnalytics/analytics-query-context";
import { ANALYTICS_TAB_INDEX } from "@/components/RequestsAnalytics/constants";
import { TracesTableRefreshProvider } from "@/components/TracesSearch/TracesAgGrid/traces-table-refresh-context";
import { TracesAnalyticsPageHeader } from "@/components/TracesSearch/TracesAnalyticsPageHeader";
import TracesAnalyticsTabs from "@/components/TracesSearch/TracesAnalyticsTabs";
import TracesSearchbar from "@/components/TracesSearch/TracesSearchbar";
import { PageWrapper } from "@/components/UnifiedRegistry/BreadcrumbsPageWrapper";
import { TimezoneProvider } from "@/context/timezone-context";

const TracesAnalyticsPage = () => {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!hasTracked.current) {
      posthog.capture("Trace Analytics Page Viewed", {
        name: "Trace Analytics",
        href: window.location.href,
      });
      hasTracked.current = true;
    }
  }, []);

  return (
    <TimezoneProvider>
      <AnalyticsQueryProvider>
        <TracesTableRefreshProvider>
          <PageWrapper className="flex h-full min-h-0 flex-col overflow-hidden px-6 pb-4 pt-8">
            <TracesAnalyticsPageHeader selectedTabIndex={ANALYTICS_TAB_INDEX} />
            <TracesSearchbar />
            <TracesAnalyticsTabs selectedTabIndex={ANALYTICS_TAB_INDEX} />
          </PageWrapper>
        </TracesTableRefreshProvider>
      </AnalyticsQueryProvider>
    </TimezoneProvider>
  );
};

export default TracesAnalyticsPage;
